import { createContext, useContext } from "react";
import { UrlFilters } from "./types";

const initialState: UrlFilters = { featured: [], secondary: {} };
const UrlFiltersContext = createContext<UrlFilters>(initialState);

const useUrlFilters = () => useContext(UrlFiltersContext);

export { UrlFiltersContext, useUrlFilters };
